import {select as d3select} from 'd3-selection';

import State from '../State/State';
import Dispatch from '../Dispatch/Dispatch';

import './Menu.css';

var container = d3select('.WorldMap-menu');

var items = [
 {id: 'cases'},
 {id: 'deaths'},
 {id: 'dalys'}
];

function init() {
	container
		.selectAll('.WorldMap-menu-item')
		.data(items)
		.on('click', (d) => {
			State.set('selectedSeries', d.id);
		});

	container
		.select('.WorldMap-menu-direct-indirect-check input')
		.on('change', function(d) {
			State.set('includeIndirectDeaths', this.checked);
		});

	container
		.select('.WorldMap-menu-stunting-check input')
		.on('change', function(d) {
			State.set('includeStunting', this.checked);
		});

	container
		.select('.WorldMap-menu-dalys-rate-radio')
		.selectAll('input[type=radio][name="WorldMap-menu-rate"]')
		.on('change', function(d) {
			// console.log('dalys rate', this.value);
			State.set('dalysByRate', this.value === 'by-rate');
		});

	Dispatch.dispatch.on('selectedSeriesUpdate.Menu', update);
}

function update() {
	container
		.selectAll('.WorldMap-menu-item')
		.classed('selected', d => d.id === State.selectedSeries);
}

var api = {
	init: init
};

export default api;




/** WEBPACK FOOTER **
 ** ./src/Menu/Menu.js
 **/